/******************************************************************************
 * FILE:
 * src/modules/expenseManagement/workflow/components/WorkflowStepTable.jsx
 *
 * MODULE:
 * Expense Management
 *
 * FEATURE:
 * Workflow Step
 *
 * PURPOSE:
 * Display Workflow Steps
 *
 * RESPONSIBILITY:
 * • Display Workflow Steps
 * • Emit User Actions
 *
 ******************************************************************************/

import React from "react";

export default function WorkflowStepTable({

    loading,

    workflowSteps = [],

    onEdit,

    onDelete,

    onMoveUp,

    onMoveDown,

    onActivate,

    onDeactivate,

}) {

    return (

        <div
            className="card shadow-sm"
            style={{
                borderRadius: "10px",
            }}
        >

            <div className="card-body p-0">

                <table
                    className="
                        table
                        table-hover
                        table-striped
                        mb-0
                        align-middle
                    "
                >

                    <thead className="table-light">

                        <tr>

                            <th width="70">
                                Seq
                            </th>

                            <th>
                                Step Name
                            </th>

                            <th width="180">
                                Approval Level
                            </th>

                            <th width="90">
                                Delegate
                            </th>

                            <th width="90">
                                Skip
                            </th>

                            <th width="90">
                                Auto
                            </th>

                            <th width="130">
                                Escalation
                            </th>

                            <th width="100">
                                Status
                            </th>

                            <th width="330">
                                Actions
                            </th>

                        </tr>

                    </thead>

                    <tbody>

                        {loading && (

                            <tr>

                                <td
                                    colSpan="9"
                                    className="text-center py-4"
                                >
                                    Loading...
                                </td>

                            </tr>

                        )}

                        {!loading &&
                            workflowSteps.length === 0 && (

                            <tr>

                                <td
                                    colSpan="9"
                                    className="text-center py-4"
                                >
                                    No Workflow Steps Found
                                </td>

                            </tr>

                        )}

                        {!loading &&
                            workflowSteps.map((step) => (

                            <tr
                                key={step.workflow_step_id}
                            >

                                <td>

                                    {step.sequence_no}

                                </td>

                                <td>

                                    {step.step_name}

                                </td>

                                <td>

                                    {
                                        step.approval_level_name ||
                                        step.approval_level_id
                                    }

                                </td>

                                <td>

                                    {step.allow_delegate
                                        ? "Yes"
                                        : "No"}

                                </td>

                                <td>

                                    {step.allow_skip
                                        ? "Yes"
                                        : "No"}

                                </td>

                                <td>

                                    {step.auto_approve
                                        ? "Yes"
                                        : "No"}

                                </td>

                                <td>

                                    {step.escalation_after_hours
                                        ? `${step.escalation_after_hours} hrs`
                                        : "-"}

                                </td>

                                <td>

                                    <span
                                        className={
                                            step.is_active
                                                ? "badge bg-success"
                                                : "badge bg-danger"
                                        }
                                    >

                                        {step.is_active
                                            ? "Active"
                                            : "Inactive"}

                                    </span>

                                </td>

                                <td>

                                    <button
                                        className="btn btn-sm btn-outline-secondary me-1"
                                        onClick={() =>
                                            onMoveUp(step)
                                        }
                                    >
                                        ↑
                                    </button>

                                    <button
                                        className="btn btn-sm btn-outline-secondary me-1"
                                        onClick={() =>
                                            onMoveDown(step)
                                        }
                                    >
                                        ↓
                                    </button>

                                    <button
                                        className="btn btn-sm btn-warning me-1"
                                        onClick={() =>
                                            onEdit(step)
                                        }
                                    >
                                        Edit
                                    </button>

                                    {step.is_active ? (

                                        <button
                                            className="btn btn-sm btn-secondary me-1"
                                            onClick={() =>
                                                onDeactivate(step)
                                            }
                                        >
                                            Deactivate
                                        </button>

                                    ) : (

                                        <button
                                            className="btn btn-sm btn-success me-1"
                                            onClick={() =>
                                                onActivate(step)
                                            }
                                        >
                                            Activate
                                        </button>

                                    )}

                                    <button
                                        className="btn btn-sm btn-danger"
                                        onClick={() =>
                                            onDelete(step)
                                        }
                                    >
                                        Delete
                                    </button>

                                </td>

                            </tr>

                        ))}

                    </tbody>

                </table>

            </div>

        </div>

    );

}